<template>
  <bulk-edit-accounts
    :is-loading="isLoading"
    :affected-accounts="affectedAccounts"
    :users="users"
    @edit="onEdit"
  />
</template>

<script>
import { API } from '@/utils/api'
import BulkEditAccounts from '../components/BulkEditAccounts.vue'

export default {
  components: {
    BulkEditAccounts,
  },
  data() {
    return {
      isLoading: false,
      affectedAccounts: [],
      users: [],
    }
  },

  mounted() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.isLoading = true

      Promise.all([this.loadUserList()])
        .finally(() => {
          this.isLoading = false
        })
    },
    loadUserList () {
      return API.call('/users/list_info.json', { with_base: 1 }).then(r => this.users = r.data)
    },

    /**
     *
     * @param {object} args
     * @param {number} args.project - project ID
     * @param {string} args.accounts - search term
     * @param {string} args.search_by - search term field
     * @param {Record<string, any>} args.form - fields to set
     */
    onEdit(args) {
      this.affectedAccounts = []

      this.$root.$confirm(
        'Confirm',
        `Edit selected accounts?`
      ).then(yes => {
        if (!yes) {
          return
        }

        this.isLoading = true
        return API.call('/$v/tools/bulk_account_edit.json', {
          ...args,
          entity_id: args.project,
        })
          .then(r => {
            this.affectedAccounts = r.result
          })
          .finally(() => {
            this.isLoading = false
          })
      })
    }
  },
}
</script>
